import axios from '@/libs/api.request'

export const getIndexData = () => {
  return axios.request({
    url: 'index',
    method: 'get'
  })
}

export const getCourseList = info => {
  return axios.request({
    url: 'course-list',
    params: info,
    method: 'get',
  })
}

export const searchCourse = info => {
  return axios.request({
    url: 'search-course',
    params: info,
    method: 'get',
  })
}

export const getCourseInfo = info => {
  return axios.request({
    url: 'course-info',
    params: info,
    method: 'get',
  })
}

export const saveCourse = info => {
  return axios.request({
    url: 'course-save',
    data: info,
    method: 'post'
  })
}

export const courseEnable = info => {
  return axios.request({
    url: 'course-enable',
    data: info,
    method: 'post'
  })
}

export const getUserList = info => {
  return axios.request({
    url: 'user-list',
    params: info,
    method: 'get',
  })
}

export const searchUser = info => {
  return axios.request({
    url: 'search-user',
    params: info,
    method: 'get',
  })
}

export const userEnable = info => {
  return axios.request({
    url: 'user-enable',
    data: info,
    method: 'post'
  })
}


export const userResetpwd = info => {
  return axios.request({
    url: 'resetpwd',
    data: info,
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url: 'save-error-logger',
    data: info,
    method: 'post'
  })
}

export const getPresentLog = info => {
  return axios.request({
    url: 'present-log',
    params: info,
    method: 'get',
  })
}

export const presentCourse = info => {
  return axios.request({
    url: 'present-course',
    data: info,
    method: 'post'
  })
}

export const getOrderList = info => {
  return axios.request({
    url: 'order-list',
    params: info,
    method: 'get',
  })
}
export const getOrderChangeList = info => {
  return axios.request({
    url: 'order-change-list',
    params: info,
    method: 'get',
  })
}

export const orderChange = info => {
  return axios.request({
    url: 'order-change',
    data: info,
    method: 'post'
  })
}

export const searchOrder = info => {
  return axios.request({
    url: 'search-order',
    params: info,
    method: 'get',
  })
}
export const cancelOrder = info => {
  return axios.request({
    url: 'cancel-order',
    data: info,
    method: 'post',
  })
}

export const salesTrackingList = info => {
  return axios.request({
    url: 'sales-tracking-list',
    params: info,
    method: 'get',
  })
}


export const salesTrackingUpdate = info => {
  return axios.request({
    url: 'sales-tracking-update',
    data: info,
    method: 'post',
  })
}

export const salesTrackingInfo = info => {
  return axios.request({
    url: 'sales-tracking-info',
    params: info,
    method: 'get',
  })
}

export const SignupParams =info => {
  return axios.request({
    url: 'school-list',
    params: info,
    method: 'get',
  })
}

export const SignupList =info => {
  return axios.request({
    url: 'user-apply-list',
    params: info,
    method: 'get',
  })
}

export const SignupUpdate = info => {
  return axios.request({
    url: 'user-apply-update',
    data: info,
    method: 'post'
  })
}

export const FeedbackList =info => {
  return axios.request({
    url: 'feedback-list',
    params: info,
    method: 'get',
  })
}

export const FeedbackUpdate = info => {
  return axios.request({
    url: 'feedback-update',
    data: info,
    method: 'post'
  })
}

export const FeedbackDelete = info => {
  return axios.request({
    url: 'feedback-delete',
    data: info,
    method: 'post'
  })
}

export const getCouponList = info => {
  return axios.request({
    url: 'coupon-list',
    params: info,
    method: 'get',
  })
}

export const searchCoupon = info => {
  return axios.request({
    url: 'search-coupon',
    params: info,
    method: 'get',
  })
}

export const couponEnable = info => {
  return axios.request({
    url: 'coupon-enable',
    data: info,
    method: 'post'
  })
}

export const couponMake = info => {
  return axios.request({
    url: 'coupon-make',
    data: info,
    method: 'post'
  })
}

export const CommentList =info => {
  return axios.request({
    url: 'comment-list',
    params: info,
    method: 'get',
  })
}


export const CommentEnable = info => {
  return axios.request({
    url: 'comment-enable',
    data: info,
    method: 'post'
  })
}

export const CommentTop = info => {
  return axios.request({
    url: 'comment-top',
    data: info,
    method: 'post'
  })
}

export const sendCoupon = info => {
  return axios.request({
    url: 'send-coupon',
    data: info,
    method: 'post'
  })
}

export const createUser = info => {
  return axios.request({
    url: 'create-user',
    data: info,
    method: 'post'
  })
}

export const userCourseList = info => {
  return axios.request({
    url: 'user-course-list',
    params: info,
    method: 'get',
  })
}


export const userCourseEnable = info => {
  return axios.request({
    url: 'user-course-enable',
    data: info,
    method: 'post'
  })
}

export const searchOfflineClasshour = info => {
  return axios.request({
    url: 'search-offline-classhour',
    params: info,
    method: 'get',
  })
}

export const getOfflineClasshour = info => {
  return axios.request({
    url: 'offline-classhour-list',
    params: info,
    method: 'get',
  })
}

export const viewQrcode = info => {
  return axios.request({
    url: 'view-qrcode',
    params: info,
    method: 'get',
  })
}
export const signInfo = info => {
  return axios.request({
    url: 'classhour-sign-info',
    params: info,
    method: 'get',
  })
}

export const signCall = info => {
  return axios.request({
    url: 'classhour-sign-call',
    params: info,
    method: 'get',
  })
}

export const signSend = info => {
  return axios.request({
    url: 'classhour-sign-send',
    params: info,
    method: 'get',
  })
}

export const sendLeavel = info => {
  return axios.request({
    url: 'classhour-sign-leavel',
    params: info,
    method: 'post',
  })
}

export const searchUserByCourse = info => {
  return axios.request({
    url: 'classhour-search-user',
    params: info,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js